module.exports = __webpack_public_path__ + "img/tips3list1img3.a3a5ed90.jpg";